import dealerRequestModalConstants    from './dealerRequestModal.constants';
import dealerRequestModalInitialState from './dealerRequestModal.state';

function dealerRequestModalReducer(state = dealerRequestModalInitialState, action) {
  switch (action.type) {
    case dealerRequestModalConstants.SHOW_MODAL:
      state = {
        open:   true,
        common: action.common,
      };
      break;

    case dealerRequestModalConstants.HIDE_MODAL:
      state = { ...dealerRequestModalInitialState };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default dealerRequestModalReducer;